// extracted by mini-css-extract-plugin
module.exports = {"appContainer":"App_appContainer__2lNSg"};